import React from 'react';
import { Route, IndexRedirect } from 'react-router';
import TabBar from '../TabBar';

import AnalysisChart from './AnalysisChart';
import AnalysisPercentile from './AnalysisChart2';
import AnalysisMap from './AnalysisMap2';
import AnalysisComparison from './AnalysisComparison';
import AnalysisMeteorologicalTemperature from './Meteorological/Temperature';
import AnalysisMeteorologicalPrecipitation from './Meteorological/Precipitation1';
import AnalysisMeteorologicalHeatIndex from './Meteorological/HeatIndex';
import AnalysisMeteorologicalWindRose from './Meteorological/WindRoseNew';
import AnalysisData from "./Data/AnalysisData";
import AnalysisDataView from "./Data/AnalysisDataView";
import AnalysisTools from "./Tools/AnalysisTools";
import DoubleMassCurve from "./Tools/DoubleMassCurve/DoubleMassCurve";
import StaffGauge from "./Tools/StaffGauge/StaffGauge";
import Graph from "../HQC/Graph";
import AddParameter from "../HQC/Add";
import HQCMap from "../HQC/Map";
import HydrologygraphView from './Hydrology/HydrologyGraph';
import HydrologyMap from './Hydrology/HydrologyMap';
import RainfallMap from './Meteorological/RainfallMap';
import RainfallGraph from './Meteorological/RainfallGraph';
import Evaporation from './Evaporation';

const Home = props => (
  <div className='inner-section-root'>
    <TabBar
      items={[
        { to: '/analysis/chart', label: 'Chart' },
        { to: '/analysis/percentile', label: 'Percentile' },
        { to: '/analysis/hydrological', label: 'Comparison' },
        { to: '/analysis/meteorological', label: 'Meteorological' },
        { to: '/analysis/map', label: 'Map' },
        { to: '/analysis/data', label: 'Data' },
        { to: '/analysis/tools', label: 'Tools' },
        { to: '/analysis/hqc', label: 'HQC' },
        { to: '/analysis/hydrology', label: 'Hydrology' },
        { to: '/analysis/evaporation', label: 'Evaporation' },
      ]}
    />
    <div className='inner-section-content'>
      {props.children}
    </div>
  </div>
);

const HQCHome = props => (
  <div>
    <TabBar
      items={[
        { to: '/analysis/hqc/graph', label: 'Graph' },
        { to: '/analysis/hqc/map', label: 'Map' },
      ]}
    />
    {props.children}
  </div>
)

const AnalysisHydrology = props => (
  <div>
    <TabBar
      items={[
        { to: '/analysis/hydrology/map', label: 'Map' },
      ]}
    /><br />
    {props.children}
  </div>
)


const AnalysisMeteorological = props => (
  <div>
    <TabBar
      items={[
        { to: '/analysis/meteorological/rainfall-map', label: 'Rainfall Map' },
        // {to: '/analysis/meteorological/temperature', label: 'Temperature Monitoring'},
        // {to: '/analysis/meteorological/precipitation', label: 'Precipitation Monitoring'},
        // {to: '/analysis/meteorological/heat-index', label: 'Heat Index'},
        {to: '/analysis/meteorological/wind-rose', label: 'Wind Rose'},
      ]}
    /><br />
    {props.children}
  </div>
)

export const AnalysisRoutes = () => (
  <Route component={Home}>
    <IndexRedirect to="chart" />
    <Route path="chart" component={AnalysisChart} />
    <Route path="percentile" component={AnalysisPercentile} />
    <Route path="hydrological" component={AnalysisComparison} />
    <Route path="meteorological" component={AnalysisMeteorological}>
      <IndexRedirect to='rainfall-map' />
      <Route path="rainfall-map" component={RainfallMap} />
      <Route path="rainfall-map/:id" component={RainfallGraph} />
      <Route path="temperature" component={AnalysisMeteorologicalTemperature} />
      <Route path="precipitation" component={AnalysisMeteorologicalPrecipitation} />
      <Route path="heat-index" component={AnalysisMeteorologicalHeatIndex} />
      <Route path="wind-rose" component={AnalysisMeteorologicalWindRose} />
    </Route>
    <Route path='evaporation' component={Evaporation} />
    <Route path='map' component={AnalysisMap} />
    <Route path='data' component={AnalysisData}>
      <Route path='view' component={AnalysisDataView} />
    </Route>
    <Route path='tools' component={AnalysisTools}>
      <IndexRedirect to='double-mass-curve' />
      <Route path='double-mass-curve' component={DoubleMassCurve} />
      <Route path='staff-gauge' component={StaffGauge} />
    </Route>
    <Route path="hqc" component={HQCHome}>
      <IndexRedirect to="graph" />
      <Route path="graph" component={Graph} name="hqc-graph" />
      <Route path="add_parameter" component={AddParameter} name="add-parameter" />
      <Route path="map" component={HQCMap} />
    </Route>
    <Route path="hydrology" component={AnalysisHydrology}>
      <IndexRedirect to="map" />
      <Route path="map" component={HydrologyMap} />
      <Route path="map/:id" component={HydrologygraphView} />
    </Route>
  </Route>

);


// WEBPACK FOOTER //
// ./src/components/Analysis/routes.js